import { ActionType, createAction } from "typesafe-actions";

import type { FiWeeklySummaryResponse } from "@mapmycustomers/shared/types/entity/fieldInsight";
import type DateRangeType from "@mapmycustomers/shared/types/range/DateRange";

import { DefaultDateRangeConfiguration } from "@app/types/dashboard/CardConfiguration";
import Scope from "@app/types/dashboard/Scope";

export type WeeklySummaryResponse = FiWeeklySummaryResponse;

export const fetchWeeklySummaryData = createAction("@dashboard/fetchWeeklySummaryData")<{
  callback: (data: WeeklySummaryResponse) => void;
  // Explicit start/end dates; when present they take priority over dateRange.
  customRange?: DateRangeType;
  dateRange: DefaultDateRangeConfiguration;
  failureCallback?: () => void;
  forceRefresh?: boolean;
  scope?: Scope;
}>();

export type WeeklySummaryActions = ActionType<typeof fetchWeeklySummaryData>;
